import {defaultImage, defaultWhatsAppImage} from '../../../assets/symbols/images/defaultImage';
import {givechakImage} from '../../../assets/symbols/images/givechakImage';
import {isImagePathSupported} from './whatsAppValidation';

export const getWhatsAppDefaultImagePath = (defaultFbImage, eventType) => {
    if(defaultFbImage.path === defaultImage) {
        return eventType === 'givechak' ? givechakImage : defaultWhatsAppImage;
    }
    if(defaultFbImage.path) {
        return defaultFbImage.path;
    }
    return eventType === 'givechak' ? givechakImage : defaultWhatsAppImage;
};

export const getWhatsAppImagePath = (image, defaultFbImage, eventType) => {
    if(image?.path && isImagePathSupported(image.path)) {
        return image.path;
    }
    return getWhatsAppDefaultImagePath(defaultFbImage, eventType);
};
